/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    blockquote: "blockquote",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "injectGlobal"
      }), "(", _jsx(_components.code, {
        children: "injectGlobal"
      }), ")"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["在 styled-components v4 中，", _jsx(_components.code, {
          children: "injectGlobal"
        }), " API 被删除并被 ", _jsx(_components.code, {
          children: "createGlobalStyle"
        }), " 取代。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "injectGlobal"
        }), " API was removed and replaced by ", _jsx(_components.code, {
          children: "createGlobalStyle"
        }), " in styled-components v4."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "编写全局 CSS 的辅助方法。它不返回组件，而是直接将样式添加到样式表中。"
    }), "\n", _jsx(_components.p, {
      children: "¥A helper method to write global CSS. It does not return a component, but adds the styles to\nthe stylesheet directly."
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "TaggedTemplateLiteral"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "A tagged template literal with your global styles inside."
          })
        })]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { injectGlobal } from 'styled-components'\n\ninjectGlobal`\n  @font-face {\n    font-family: \"Operator Mono\";\n    src: url(\"../fonts/Operator-Mono.ttf\");\n  }\n\n  body {\n    margin: 0;\n  }\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["我们不鼓励使用此功能。如果必须的话，尝试在每个应用中最多使用一次它，并将其包含在单个文件中。这是一个应急方案。仅将其用于罕见的 ", _jsx(_components.code, {
        children: "@font-face"
      }), " 定义或主体样式。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We do not encourage the use of this. Try to use it once per app at most, if you\nmust, contained in a single file. This is an escape hatch. Only use it for the\nrare ", _jsx(_components.code, {
        children: "@font-face"
      }), " definition or body styling."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
